import { lazy } from "react"

// Reached only by developers signing in from a PR link, so these stay out of the main bundle.
export const ScmCallbackPage = lazy(() =>
  import("./components/pages/ScmCallbackPage").then((module) => ({
    default: module.ScmCallbackPage
  }))
)
export const ScmSignInStartPage = lazy(() =>
  import("./components/pages/ScmSignInStartPage").then((module) => ({
    default: module.ScmSignInStartPage
  }))
)
